'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { isValidElement, cloneElement, Component } from 'react';
import I18n from 'I18n';
import { getPassThroughProps, interpolateToArray } from './utils';
export default class FormattedReactMessage extends Component {
  constructor(...args) {
    super(...args);

    this.getEscapedParam = (param, key, index) => {
      if (! /*#__PURE__*/isValidElement(key)) {
        return /*#__PURE__*/_jsx("span", {
          dangerouslySetInnerHTML: {
            __html: I18n.formatParam(param, key)
          }
        }, `${param}-${index}`);
      }

      return /*#__PURE__*/cloneElement(key, {
        key: `${param}-${index}`,
        ref: key.ref
      });
    };

    this.renderFormattedMessage = () => {
      return interpolateToArray(this.props.message, this.props.options, this.getEscapedParam);
    };
  }

  render() {
    const props = getPassThroughProps(this.props);
    return /*#__PURE__*/_jsx("span", Object.assign({}, props, {
      children: this.renderFormattedMessage()
    }));
  }

}
FormattedReactMessage.displayName = 'FormattedReactMessage';
FormattedReactMessage.propTypes = {
  message: PropTypes.string.isRequired,
  options: PropTypes.object,
  useGap: PropTypes.bool
};
FormattedReactMessage.isI18nElement = true;
FormattedReactMessage.defaultProps = {
  options: {},
  useGap: false
};